const COOKIEBOT_WIDGET_ID = 'CookiebotWidget'

// Widget zostaje widoczny tylko na stronie głównej. Zwraca false też gdy
// element jeszcze nie istnieje w DOM (Cookiebot ładuje się asynchronicznie) —
// wywołujący decyduje, czy i jak ponowić próbę.
function hideCookieBotWidget (pathname, htmlId = COOKIEBOT_WIDGET_ID) {
    if (pathname === '/') return false

    const cbw = document.getElementById(htmlId)
    if (!cbw) return false

    cbw.style.visibility = 'hidden'
    return true
}

export default hideCookieBotWidget
export {
    COOKIEBOT_WIDGET_ID,
}
